import { denormalize, normalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { entitiesFetchSuccess } from '../../store/entities/actions';
import { documentsSchema, foldersSchema, tagsSchema } from '../../store/schema';
import {
  fetchDeletedDocumentsSuccess,
  fetchDeletedFoldersSuccess,
  restoreDocumentsSuccess,
} from './actions';
import { getEntities } from '../../store/entities/selectors';


const fetchDeletedDocuments = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_DOCUMENTS),
  switchMap((action) => api.trash.fetchDeletedDocuments(action.spaceId).pipe(
    map((response) => normalize(response.body, documentsSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchDeletedDocumentsSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchDeletedFolders = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_FOLDERS),
  switchMap((action) => api.trash.fetchDeletedFolders(action.spaceId).pipe(
    map((response) => normalize(response.body, foldersSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchDeletedFoldersSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

const restoreDocuments = (action$, state$) => action$.pipe(
  ofType(actionTypes.RESTORE_DOCUMENTS),
  switchMap((action) => {
    const documents = action.documents.map((document) => {
      const doc = document;
      if (doc.tags) {
        doc.tags = denormalize(document.tags, tagsSchema, getEntities(state$.value));
      }
      return doc;
    });
    return api.trash.restoreDocuments(documents).pipe(
      mergeMap(() => [
        restoreDocumentsSuccess(action.documents.map((doc) => doc.id)),
      ]),
      catchError((error) => [handleError(error)]),
    );
  }),
);


export default combineEpics(
  fetchDeletedDocuments,
  fetchDeletedFolders,
  restoreDocuments,
);
